export default {
  setUrnsIndex(state, urnList) {
    state.urnIndex = urnList
  },
  setUrnMetadata(state, metadata) {
    state.urnMetadata = metadata
  }
}
